import Phaser from "phaser";
import { POWERUP_DESPAWN_MS, POWERUP_MAX_ACTIVE, POWERUP_MAX_SPAWN_MS, POWERUP_MIN_SPAWN_MS } from "../../game/constants";
import { PowerUpType } from "../../data/enums";
import { FishFrenzyPowerUp } from "./FishFrenzyPowerUp";
import { GasCanPowerUp } from "./GasCanPowerUp";
import { PowerUpBase } from "./PowerUpBase";
import { SpeedBoostPowerUp } from "./SpeedBoostPowerUp";
import { WeaponPowerUp } from "./WeaponPowerUp";

interface PowerUpSpawnerConfig {
    scene: Phaser.Scene;
    group: Phaser.GameObjects.Group;
    worldWidth: number;
    worldHeight: number;
}

export class PowerUpSpawner {
    private readonly scene: Phaser.Scene;
    private readonly group: Phaser.GameObjects.Group;
    private readonly worldWidth: number;
    private readonly worldHeight: number;
    private nextSpawnAt = 0;

    constructor(config: PowerUpSpawnerConfig) {
        this.scene = config.scene;
        this.group = config.group;
        this.worldWidth = config.worldWidth;
        this.worldHeight = config.worldHeight;
        this.scheduleNextSpawn();
    }

    update(time: number): void {
        this.group.getChildren().forEach((child) => {
            const powerUp = child as PowerUpBase;
            powerUp.update(time);
            if (time >= powerUp.expiresAt) {
                this.group.remove(powerUp, true, true);
            }
        });

        if (time < this.nextSpawnAt) {
            return;
        }
        if (this.group.getLength() >= POWERUP_MAX_ACTIVE) {
            this.scheduleNextSpawn();
            return;
        }

        this.group.add(this.createRandomPowerUp());
        this.scheduleNextSpawn();
    }

    private scheduleNextSpawn(): void {
        this.nextSpawnAt = this.scene.time.now + Phaser.Math.Between(POWERUP_MIN_SPAWN_MS, POWERUP_MAX_SPAWN_MS);
    }

    private createRandomPowerUp(): PowerUpBase {
        const x = Phaser.Math.Between(120, this.worldWidth - 120);
        const y = Phaser.Math.Between(120, this.worldHeight - 120);
        const type = Phaser.Utils.Array.GetRandom([PowerUpType.Trident, PowerUpType.Bow, PowerUpType.GasCan, PowerUpType.SpeedBoost, PowerUpType.FishFrenzy]);

        switch (type) {
            case PowerUpType.Trident:
            case PowerUpType.Bow:
                return new WeaponPowerUp(this.scene, x, y, type);
            case PowerUpType.GasCan:
                return new GasCanPowerUp(this.scene, x, y);
            case PowerUpType.SpeedBoost:
                return new SpeedBoostPowerUp(this.scene, x, y);
            default:
                return new FishFrenzyPowerUp(this.scene, x, y);
        }
    }
}
